import React, { useState, useEffect, useCallback } from 'react';
import './AdminPanel.css';

// ==========================================================
// #1: کامپوننت داخلی برای "ایجاد پروژه"
// ==========================================================
const CreateProjectView = ({ onProjectCreated }) => {
    const [projectName, setProjectName] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [logoFile, setLogoFile] = useState(null);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');
        setError('');
        const token = localStorage.getItem('superAdminAuthToken');

        // --- شروع تغییر اصلی: ساخت یک FormData واحد ---
        const formData = new FormData();
        formData.append('projectName', projectName);
        formData.append('username', username);
        formData.append('password', password);
        if (logoFile) {
            formData.append('logo', logoFile);
        }
        // --- پایان تغییر اصلی ---

        try {
            const response = await fetch('https://sseo.afaq.lc/seo_architect_api/create_project.php', {
                method: 'POST',
                headers: {
                    // 'Content-Type' را حذف می‌کنیم تا مرورگر آن را به صورت خودکار تنظیم کند
                    'Authorization': `Bearer ${token}`
                },
                body: formData, // ارسال FormData به جای JSON
            });

            const data = await response.json();

            if (data.success) {
                let finalMessage = `پروژه با موفقیت ایجاد شد! آدرس ورود: /?project=${data.project.slug}`;
                if (data.project.logoPath) {
                    finalMessage += " | لوگو آپلود شد.";
                }
                setMessage(finalMessage);
                onProjectCreated();
                setProjectName(''); setUsername(''); setPassword(''); setLogoFile(null);
            } else {
                throw new Error(data.message || 'خطا در ایجاد پروژه.');
            }
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="admin-view">
            <h2>ایجاد پروژه جدید</h2>
            <form onSubmit={handleSubmit} className="admin-form-grid">
                <input type="text" value={projectName} onChange={e => setProjectName(e.target.value)} placeholder="نام پروژه" required />
                <input type="text" value={username} onChange={e => setUsername(e.target.value)} placeholder="نام کاربری مدیر" required />
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="رمز عبور مدیر" required />
                <div className="file-input-wrapper">
                    <label htmlFor="logo-upload">{logoFile ? logoFile.name : 'انتخاب لوگو (اختیاری)'}</label>
                    <input id="logo-upload" type="file" onChange={e => setLogoFile(e.target.files[0])} accept="image/*" />
                </div>
                <button type="submit" disabled={loading} className="full-width">{loading ? 'در حال ایجاد...' : 'ایجاد پروژه'}</button>
            </form>
            {message && <p className="message-box success">{message}</p>}
            {error && <p className="message-box error">{error}</p>}
        </div>
    );
};
// ==========================================================
// #2: کامپوننت داخلی برای "لیست پروژه‌ها"
// ==========================================================
const ProjectsListView = ({ projects, refreshProjects }) => {
    const handleEdit = async (projectId, currentName) => {
        const newName = window.prompt("نام جدید پروژه را وارد کنید:", currentName);
        if (newName && newName.trim() !== "") {
            try {
                const res = await fetch('https://sseo.afaq.lc/seo_architect_api/edit_project.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('superAdminAuthToken')}` },
                    body: JSON.stringify({ projectId, newName: newName.trim() }),
                });
                const data = await res.json();
                if (!data.success) throw new Error(data.message);
                refreshProjects();
            } catch (err) { alert(err.message || 'خطا در ویرایش پروژه.'); }
        }
    };

    const handleDelete = async (projectId) => {
        if (!window.confirm("آیا از حذف این پروژه و تمام داده‌های آن مطمئن هستید؟")) return;
        try {
            const res = await fetch('https://sseo.afaq.lc/seo_architect_api/delete_project.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('superAdminAuthToken')}` },
                body: JSON.stringify({ projectId }),
            });
            const data = await res.json();
            if (!data.success) throw new Error(data.message);
            refreshProjects();
        } catch (err) { alert(err.message || 'خطا در حذف پروژه.'); }
    };

    if (projects.length === 0) {
        return <div className="admin-view"><p>هنوز پروژه‌ای ایجاد نشده است. برای شروع، یک پروژه جدید بسازید.</p></div>;
    }

    return (
        <div className="admin-view table-view">
            <h2>لیست پروژه‌ها</h2>
            <table className="projects-table">
                <thead><tr><th>نام پروژه</th><th>آدرس ورود</th><th>کاربران</th><th>عملیات</th></tr></thead>
                <tbody>
                    {projects.map(p => (
                        <tr key={p.id}>
                            <td>{p.name}</td>
                            <td><a href={`/?project=${p.slug}`} target="_blank" rel="noopener noreferrer">{`/?project=${p.slug}`}</a></td>
                            <td>{p.users.map(u => u.username).join(', ')}</td>
                            <td className="actions-cell">
                                <button onClick={() => handleEdit(p.id, p.name)} className="btn-edit">ویرایش</button>
                                <button onClick={() => handleDelete(p.id)} className="btn-delete">حذف</button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

// ==========================================================
// #3: کامپوننت داخلی برای "مدیریت کاربران"
// ==========================================================
const ManageUsersView = ({ projects, refreshProjects }) => {
    const [selectedProjectId, setSelectedProjectId] = useState('');
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedProjectId) { setError('لطفاً یک پروژه را انتخاب کنید.'); return; }
        setLoading(true); setMessage(''); setError('');
        try {
            const res = await fetch('https://sseo.afaq.lc/seo_architect_api/add_user.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('superAdminAuthToken')}` },
                body: JSON.stringify({ projectId: selectedProjectId, username, password }),
            });
            const data = await res.json();
            if (data.success) {
                setMessage(data.message);
                setUsername(''); setPassword('');
                refreshProjects();
            } else { throw new Error(data.message); }
        } catch (err) { setError(err.message); } finally { setLoading(false); }
    };

    const handleDeleteUser = async (userId, username) => {
        if (!window.confirm(`آیا از حذف کاربر "${username}" مطمئن هستید؟`)) return;
        setMessage(''); setError('');
        try {
            const res = await fetch('https://sseo.afaq.lc/seo_architect_api/delete_user.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('superAdminAuthToken')}` },
                body: JSON.stringify({ userId }),
            });
            const data = await res.json();
            if (data.success) {
                setMessage(data.message);
                refreshProjects();
            } else { throw new Error(data.message); }
        } catch (err) { setError(err.message || 'خطا در حذف کاربر.'); }
    };

    const selectedProject = projects.find(p => p.id === parseInt(selectedProjectId));

    return (
        <div className="admin-view">
            <h2>مدیریت کاربران پروژه</h2>
            <form onSubmit={handleSubmit} className="admin-form-grid user-manage-form">
                <select value={selectedProjectId} onChange={e => {setSelectedProjectId(e.target.value); setMessage(''); setError('');}} required>
                    <option value="">-- یک پروژه را انتخاب کنید --</option>
                    {projects.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                </select>
                <input type="text" value={username} onChange={e => setUsername(e.target.value)} placeholder="نام کاربری جدید" required />
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="رمز عبور" required />
                <button type="submit" disabled={loading} className="full-width">{loading ? 'در حال افزودن...' : 'افزودن کاربر'}</button>
            </form>
            {message && <p className="message-box success">{message}</p>}
            {error && <p className="message-box error">{error}</p>}
            {selectedProject && (
                <div className="user-list-container">
                    <h3>کاربران پروژه: {selectedProject.name}</h3>
                    <ul className="user-list">
                        {selectedProject.users.map(user => (
                            <li key={user.id}>
                                <span>{user.username}</span>
                                <button onClick={() => handleDeleteUser(user.id, user.username)} className="btn-delete-user">حذف</button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
};

// ==========================================================
// #4: کامپوننت اصلی و والد پنل ادمین
// ==========================================================
const AdminPanel = ({ onLogout }) => {
    const [activeView, setActiveView] = useState('list');
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const fetchProjects = useCallback(async () => {
        setLoading(true);
        setError('');
        try {
            const res = await fetch('https://sseo.afaq.lc/seo_architect_api/get_projects.php', {
                headers: { 'Authorization': `Bearer ${localStorage.getItem('superAdminAuthToken')}` }
            });
            const data = await res.json();
            if (data.success) {
                setProjects(data.projects);
            } else {
                throw new Error(data.message || 'خطا در دریافت لیست پروژه‌ها.');
            }
        } catch (err) { 
            setError(err.message);
            if (err.message.includes("توکن")) onLogout(); // اگر توکن نامعتبر بود، لاگ‌اوت کن
        } finally { 
            setLoading(false); 
        }
    }, [onLogout]);

    useEffect(() => {
        fetchProjects();
    }, [fetchProjects]);

    return (
        <div className="admin-layout">
            <aside className="admin-sidebar">
                <h3>پنل مدیریت</h3>
                <ul>
                    <li className={activeView === 'list' ? 'active' : ''} onClick={() => setActiveView('list')}>لیست پروژه‌ها</li>
                    <li className={activeView === 'create' ? 'active' : ''} onClick={() => setActiveView('create')}>ایجاد پروژه</li>
                    <li className={activeView === 'manage' ? 'active' : ''} onClick={() => setActiveView('manage')}>مدیریت کاربران</li>
                </ul>
                <button onClick={onLogout} className="admin-logout-btn">خروج</button>
            </aside>
            <main className="admin-content">
                {loading && <p>در حال بارگذاری اطلاعات...</p>}
                {error && <p className="message-box error">{error}</p>}
                {!loading && !error && (
                    <>
                        <div style={{ display: activeView === 'list' ? 'block' : 'none' }}><ProjectsListView projects={projects} refreshProjects={fetchProjects} /></div>
                        <div style={{ display: activeView === 'create' ? 'block' : 'none' }}><CreateProjectView onProjectCreated={fetchProjects} /></div>
                        <div style={{ display: activeView === 'manage' ? 'block' : 'none' }}><ManageUsersView projects={projects} refreshProjects={fetchProjects} /></div>
                    </>
                )}
            </main>
        </div>
    );
};

export default AdminPanel;
